import * as PropTypes from 'prop-types';
import * as React from 'react';
import RoutingNumberField from '../routing_number_field';
import CurrencyWarnings from '../currency_warnings';
import CountryCodeInput from './country_code_input';
import ErrorMessage from '../../../shared/error_message';
import * as EXAMPLE_CHECK_IMAGE from '../../../../../images/listing-form/example-check.png';
import { CURRENCY_CODES } from '../../../shared/constants';

const UNITED_STATES_COUNTRY_CODE = 'US';

class USBankFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      routingNumberError: null,
      showValidBankInfo: false,
      bankName: '',
      routingNumber: '',
    };
  }

  handleRoutingNumberBlur(routingNumber) {
    const req = $.ajax({
      type: 'get',
      url: this.props.bankLookupUrl,
      dataType: 'text',
      data: { routing_number: routingNumber.value },
    });

    req.success(response => this.success(response));
    req.fail(response => this.fail(response));
  }

  success(response) {
    this.setState({
      routingNumberError: null,
      showValidBankInfo: true,
      bankName: JSON.parse(response).name,
    });
  }

  fail() {
    this.setState({
      routingNumberError: I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.invalidRouting'),
      showValidBankInfo: false,
      bankName: '',
    });
  }

  formattedNameForCurrency() {
    return this.props.currencies[0].name;
  }

  displayValidBankInfo() {
    if (!this.state.showValidBankInfo) { return false; }
    return (
      <div>
        <hr />
        <p className="mb-0">
          <b>{this.state.bankName}</b>
        </p>
        <hr className="mb-1" />
      </div>
    );
  }

  displayRoutingNumberError() {
    if (!this.state.routingNumberError) { return false; }

    return (
      <ErrorMessage
        message={this.state.routingNumberError}
        alertStyle="alert-warn alert-small"
      />
    );
  }

  render() {
    return (
      <div>
        <div className="g-container">
          <div className="g-col-6 g-col-mobile-12">
            <label>
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.nameOnAccount')}
            </label>
            <input
              className="string required wide mb-0"
              autoFocus="on"
              type="text"
              name={this.props.nameForField('name_on_account')}
            />
          </div>
          <div className="g-col-6 g-col-mobile-12 mobile-mt-1">
            <label>
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.accountType')}
            </label>
            <ul className="inline-list horizontal-padded-list scaling-pt-half">
              <li>
                <label className="inline">
                  <input
                    required="required"
                    type="radio"
                    value="checking"
                    defaultChecked
                    name={this.props.nameForField('bank_account_type')}
                  />
                  <span>
                    {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.checkingRadio')}
                  </span>
                </label>
              </li>
              <li>
                <label className="inline">
                  <input
                    required="required"
                    type="radio"
                    value="savings"
                    name={this.props.nameForField('bank_account_type')}
                  />
                  <span>
                    {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.savingsRadio')}
                  </span>
                </label>
              </li>
            </ul>
          </div>
        </div>

        <div className="mb-1">
          <div className="g-container">
            <CountryCodeInput
              countryCode={UNITED_STATES_COUNTRY_CODE}
              countryCodeOptions={this.props.countryCodeOptions}
              nameForField={fieldName => this.props.nameForField(fieldName)}
              onCountryChange={countryCode => this.props.onCountryChange(countryCode)}
            />
            <div className="g-col-6">
              <label className="string required">
                {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.currencyInput.label')}
              </label>
              <input
                type="hidden"
                name={this.props.nameForField('currency')}
                value={CURRENCY_CODES.USD}
              />
              <div>{this.formattedNameForCurrency()}</div>
            </div>
          </div>

          <CurrencyWarnings
            payoutCurrency={CURRENCY_CODES.USD}
            defaultCurrencyForBankCountry={CURRENCY_CODES.USD}
            shopCurrency={this.props.shopCurrency}
            dashboardView={this.props.dashboardView}
            nameForField={this.props.nameForField}
          />
        </div>

        <div className="g-container">
          <div className="g-col-6 g-col-mobile-12">
            <label className="string required">
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.routingNumber')}
            </label>
            <RoutingNumberField
              handleOnBlur={routingNumber => this.handleRoutingNumberBlur(routingNumber)}
              name={this.props.nameForField('routing_number')}
            />
          </div>

          <div className="g-col-6 g-col-mobile-12">
            <label className="string required">
              {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.accountNumber')}
            </label>
            <input
              className="string required wide"
              maxLength="17"
              type="text"
              name={this.props.nameForField('bank_account_number')}
            />
          </div>
        </div>
        {this.displayRoutingNumberError()}
        {this.displayValidBankInfo()}
        <div className="toggler mb-0" rel="example-check">
          <a className="small" href="#">
            {I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.findBankNumbers')}
          </a>
        </div>
        <div className="toggleable ptb-1" id="example-check">
          <img
            src={EXAMPLE_CHECK_IMAGE}
            className="example-check-img"
            alt={I18n.t('js.dashboard.selling.shopPolicies.directCheckoutProfile.bankAccountFields.exampleCheckAlt')}
          />
        </div>
      </div>
    );
  }
}

USBankFields.propTypes = {
  bankLookupUrl: PropTypes.string.isRequired,
  nameForField: PropTypes.func.isRequired,
  onCountryChange: PropTypes.func.isRequired,
  countryCodeOptions: PropTypes.array.isRequired,
  shopCurrency: PropTypes.string.isRequired,
  currencies: PropTypes.array.isRequired,
  dashboardView: PropTypes.bool.isRequired,
};

export default USBankFields;



// WEBPACK FOOTER //
// ./javascripts/components/shop/direct_checkout_profile/bank_account_fields/us_bank_fields.jsx